function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5443 10.4561C12.7252 9.63732 11.6144 9.17737 10.4563 9.17737C9.29815 9.17737 8.18741 9.63732 7.3683 10.4561L4.2793 13.5441C3.46018 14.3632 3 15.4742 3 16.6326C3 17.791 3.46018 18.902 4.2793 19.7211C5.09842 20.5402 6.20939 21.0004 7.3678 21.0004C8.52621 21.0004 9.63718 20.5402 10.4563 19.7211L12.0003 18.1771",
  stroke: "#5575FA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.457 13.5441C11.2761 14.3628 12.3869 14.8228 13.545 14.8228C14.7032 14.8228 15.8139 14.3628 16.633 13.5441L19.722 10.4561C20.5412 9.63693 21.0013 8.52597 21.0013 7.36755C21.0013 6.20914 20.5412 5.09818 19.722 4.27905C18.9029 3.45993 17.7919 2.99976 16.6335 2.99976C15.4751 2.99976 14.3642 3.45993 13.545 4.27905L12.001 5.82305",
  stroke: "#5575FA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLinkIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link-icon.86e22f69.svg";
export { ForwardRef as ReactComponent };